import { render, staticRenderFns } from "./DashNotification.vue?vue&type=template&id=c5bc1ae8&scoped=true&"
import script from "./DashNotification.vue?vue&type=script&lang=js&"
export * from "./DashNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashNotification.vue?vue&type=style&index=0&id=c5bc1ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bc1ae8",
  null
  
)

export default component.exports